import { useSidebar } from '@/contexts/SidebarContext'
import { cn } from '@/lib/utils'

export interface SidebarNavSectionProps {
  /** Section label (e.g. "WORK", "ANALYTICS") */
  label?: string
  /** Child nav items */
  children: React.ReactNode
  /** Additional CSS classes */
  className?: string
}

/**
 * Groups sidebar nav items under an optional section header.
 * In collapsed mode, shows a thin divider instead of text.
 */
export function SidebarNavSection({ label, children, className }: SidebarNavSectionProps) {
  const { collapsed } = useSidebar()

  return (
    <div className={cn('space-y-1', className)}>
      {label && (
        collapsed ? (
          <div className="mx-3 my-2 h-px bg-sidebar-border" />
        ) : (
          <p className="px-3 pt-4 pb-1 text-[10px] font-semibold uppercase tracking-widest text-sidebar-foreground/50">
            {label}
          </p>
        )
      )}
      <div className="space-y-0.5">{children}</div>
    </div>
  )
}
